import { Verification } from "../../../services/verifyService/model";
import { CompositeSpecification } from "../../../utils/Specification";

export class OOPMetMustBeLessThanOOPMax extends CompositeSpecification<Verification>{
    IsSatisfiedBy(candidate: Verification): boolean {
        return Number(candidate.benefits.outOfPocketMet) <= Number(candidate.benefits.outOfPocket);
    }

}